module.exports = "/assets/data/9edeba1be4aea988547fce17dc53a255-S17.data.json";